/*global Highcharts */
const charts = {
	el: {
		pie: document.querySelectorAll('.js-chart-pie'),
		bar: document.querySelectorAll('.js-chart-bar'),
		column: document.querySelectorAll('.js-chart-column'),
		spline: document.querySelectorAll('.js-chart-spline')
	},

	fxRenderChartsPie() {
		for (const pie of this.el.pie) {

			const options = {
				credits: false,
				chart: {
					type: 'pie',
					height: 200
				},
				title: {
					text: ''
				},
				legend: {
					align: 'right',
					verticalAlign: 'middle',
					layout: 'vertical',
					itemWidth: 200,
					itemStyle: {
						textOverflow: 'clip'
					}
				},
				tooltip: {
					pointFormat: '{series.name}: <strong>{point.y}</strong> ({point.percentage:.1f}%)'
				},
				plotOptions: {
					pie: {
						colors: JSON.parse(pie.dataset.chartColors),
						innerSize: 130,
						size: 175,
						dataLabels: {
							enabled: false
						},
						showInLegend: true
					}
				},
				series: JSON.parse(pie.dataset.chartData),
				responsive: {
					rules: [{
						condition: {
							maxWidth: 400
						},
						chartOptions: {
							plotOptions: {
								pie: {
									innerSize: 75,
									size: 120
								}
							},
							legend: {
								itemWidth: null,
								align: 'center',
								verticalAlign: 'bottom',
								layout: 'horizontal'
							}
						}
					}]
				}
			}

			Highcharts.chart(pie, options)
		}
	},

	fxRenderChartsBar() {
		for (const bar of this.el.bar) {

			const options = {
				credits: false,
				chart: {
					type: 'bar'
				},
				title: {
					text: ''
				},
				tooltip: {
					formatter: function() {
						const percentage = this.y / this.series.data.map(point => point.y).reduce((a, b) => a + b, 0) * 100,
							hasPercentage = !bar.classList.contains('js-chart-bar-no-percentage') ? `(${Highcharts.numberFormat(percentage, 1)}%)` : ''

						return ` ${this.x} <br /> ${this.series.name}: <strong>${this.y}</strong> ${hasPercentage}`
					}
				},
				plotOptions: {
					bar: {
						colors: JSON.parse(bar.dataset.chartColors),
						colorByPoint: true,
						pointWidth: 20,
						dataLabels: {
							enabled: false
						},
						showInLegend: false
					}
				},
				xAxis: {
					categories: JSON.parse(bar.dataset.chartCategories)
				},
				yAxis: {
					min: 0,
					allowDecimals: false,
					lineColor: '#ccd6eb',
					lineWidth: 1,
					endOnTick: false,
					title: ''
				},
				series: [{
					name: bar.dataset.chartName,
					data: JSON.parse(bar.dataset.chartData).map(el => Number(el))
				}]
			}

			Highcharts.chart(bar, options)
		}
	},

	fxRenderChartsColumn() {
		for (const column of this.el.column) {

			const options = {
				credits: false,
				chart: {
					type: column.classList.contains('js-chart-column-stacked-horizontal') ? 'bar' : 'column'
				},
				colors: JSON.parse(column.dataset.chartColors),
				title: {
					text: ''
				},
				legend: {
					align: 'left',
					itemStyle: {
						textOverflow: 'clip'
					}
				},
				tooltip: {
					headerFormat: column.classList.contains('js-chart-column-stacked') ? '<strong>{point.x}</strong><br />' : `{series.name}: <strong>{point.y}${column.classList.contains('js-chart-column-percentage') ? '%' : '' } </strong>`,
					pointFormat: column.classList.contains('js-chart-column-stacked') ? '{series.name}: {point.y}<br />Total: {point.stackTotal}' : undefined
				},
				plotOptions: {
					bar: {
						stacking: column.classList.contains('js-chart-column-stacked-horizontal') ? 'normal' : undefined
					},
					column: {
						stacking: column.classList.contains('js-chart-column-stacked') ? 'normal' : undefined,
						dataLabels: {
							enabled: false
						},
						showInLegend: true
					}
				},
				xAxis: {
					categories: JSON.parse(column.dataset.chartCategories)
				},
				yAxis: {
					min: 0,
					allowDecimals: false,
					lineColor: '#ccd6eb',
					lineWidth: 1,
					endOnTick: false,
					reversedStacks: false,
					title: ''
				},
				series: JSON.parse(column.dataset.chartData)
			}

			Highcharts.chart(column, options)
		}
	},

	fxRenderChartsSpline() {
		for (const spline of this.el.spline) {

			const options = {
				credits: false,
				chart: {
					type:'areaspline'
				},
				colors: JSON.parse(spline.dataset.chartColors),
				title: {
					text: ''
				},
				legend: {
					align: 'left',
					itemStyle: {
						textOverflow: 'clip'
					}
				},
				tooltip: {
					shared: true
				},
				plotOptions: {
					areaspline: {
						fillOpacity: 0.15
					}
				},
				xAxis: {
					categories: JSON.parse(spline.dataset.chartCategories)
				},
				yAxis: {
					min: 0,
					allowDecimals: false,
					lineColor: '#ccd6eb',
					lineWidth: 1,
					endOnTick: false,
					title: ''
				},
				series: JSON.parse(spline.dataset.chartData)
			}

			Highcharts.chart(spline, options)
		}
	},

	events() {
		window.addEventListener('load', () => {
			this.fxRenderChartsBar()
			this.fxRenderChartsPie()
			this.fxRenderChartsColumn()
			this.fxRenderChartsSpline()
		})
	},

	init() {
		this.events()
	}
}

charts.init()